import React from 'react';
import { usePrototype } from '../../contexts/PrototypeContext';
import { productImages, siteConfig } from '../../data/siteConfig';
import { useAnchorNavigation } from '../../hooks/useAnchorNavigation';
import { buttonClasses } from '../../utils/buttonStyles';
import { formatPrice } from '../../utils/currency';
export function Hero() {
  const {
    seasonConfig
  } = usePrototype();
  const goTo = useAnchorNavigation();
  const {
    product,
    fulfillment
  } = siteConfig;
  return <section aria-labelledby="hero-title" className="mx-auto grid max-w-page items-center gap-6 px-5 pb-12 pt-6 md:gap-10 md:px-10 md:pb-16 md:pt-12 lg:grid-cols-2 lg:gap-20 lg:pb-24 lg:pt-16" data-id="element-188" data-mp="5pgu5e9dtcr5">
      <div className="order-2 max-w-xl lg:order-1" data-id="element-189" data-mp="3rx6vdc31xvuk">
        <div className="flex items-center gap-3" data-id="element-190" data-mp="3ryhyrasl51l5">
          <span aria-hidden="true" className={`h-px w-10 shrink-0 transition-colors duration-200 ${seasonConfig.accentRuleClass}`} data-id="element-191" data-mp="1v4wwa9ow1y7j" />
          <p className={`min-w-0 text-[14px] font-medium [overflow-wrap:anywhere] transition-colors duration-200 ${seasonConfig.accentTextClass}`} data-id="element-192" data-mp="1q5ttkvwds42q">
            {seasonConfig.heroEyebrow}
          </p>
        </div>
        <h1 id="hero-title" className="mt-4 font-display text-[42px] md:mt-6 font-medium leading-[1.02] tracking-[-0.01em] text-ink md:text-[64px] lg:text-[76px]" data-id="element-193" data-mp="1rwqmi167j71z">
          Meet your new skincare ritual.
        </h1>
        <p className="mt-4 max-w-lg text-[16px] md:mt-6 leading-relaxed text-ink-muted md:text-[18px]" data-id="element-194" data-mp="25mak6skxle4f">
          A facial light-therapy mask for men and women, with a white silicone design and hands-free voice control.
        </p>
        <div className="mt-6 flex flex-col md:mt-9 gap-3 sm:flex-row" data-id="element-195" data-mp="1vw92qjn32tyh">
          <a href="/#the-mask" onClick={goTo('the-mask')} className={buttonClasses('primary')} data-id="element-196" data-mp="20vc0dj0qhxwf">
            Shop the mask
          </a>
          <a href="/#details" onClick={goTo('details')} className={buttonClasses('secondary')} data-id="element-197" data-mp="2ok4wpgl9q7rk">
            Explore the details
          </a>
        </div>
        <div className="mt-4 md:mt-8" data-id="element-198" data-mp="338wvyu6h5sfv">
          <p className="flex flex-wrap items-baseline gap-x-3 text-[14px] text-ink-muted" data-id="element-199" data-mp="337vadvru1njw">
            <span className="text-xl font-medium tabular-nums text-ink" data-id="element-200" data-mp="2yalkkf0j79vj">{formatPrice(product.samplePrice)}</span>
            <span data-id="element-201" data-mp="2u5vrsz166beu"><span className="sr-only" data-id="element-202" data-mp="2u5vu55on6ni0">Regular price </span><s data-id="element-203" data-mp="2p95e2icu7rwl">{formatPrice(product.regularPrice)}</s></span>
            <span data-id="element-204" data-mp="2paq6o2fld0rt">Available in {product.color}</span>
          </p>
          <p className="mt-1 text-[13px] leading-relaxed text-ink-muted" data-id="element-205" data-mp="2kaau3d34vxaw">{fulfillment.shippingLabel} · {fulfillment.dispatch}</p>
        </div>
      </div>

      <div className="order-1 lg:order-2" data-id="element-206" data-mp="2ajpqfb8ls2l4">
        <div className={`flex items-center justify-center rounded-md px-6 py-4 transition-colors duration-200 ease-out md:py-14 lg:min-h-[560px] ${seasonConfig.heroPanelClass}`} data-id="element-207" data-mp="2akizwjyy566y">
          {/* White.jpg is 368px wide — kept at or below native size. */}
          <figure className="w-full max-w-[170px] md:max-w-[368px]" data-id="element-208" data-mp="1wjeys5zgyjyw">
            <div className="overflow-hidden rounded-[4px] bg-surface" data-id="element-209" data-mp="1wmawpubbh8nc">
              <img src={productImages.white.src} alt={productImages.white.alt} width={368} height={368} className="block h-auto w-full scale-[1.04]" data-id="element-210" data-mp="c1nx5szppgap" />
            </div>
            <figcaption className={`sr-only text-[13px] md:not-sr-only md:mt-4 md:text-center transition-colors duration-200 ${seasonConfig.heroCaptionClass}`} data-id="element-211" data-mp="q1yqd2ohv6z1">
              Shown in White, the launch color.
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}